import { Navigate } from 'react-router-dom';
import { getAuthentication, getSchoolContext } from './hooks/useAuthentication';

export enum RoutesEnum {
  DEFAULT,
  KNOWLEDGE_BASE,
  PODCAST,
  LEARN,
  REPORTING_TOOLS,
  MANAGE_STAFFS,
  MISSION,
  BOOKMARK,
  SEARCH,
  RESOURCE_HUB,
}

export function isAuthorized(route: RoutesEnum) {
  const schoolContext = getSchoolContext();
  const authentication = getAuthentication();
  if (!schoolContext?.subscription) return false;
  const { search, knowledgeBase, mission, learn, bookmark, resourceHub, podcast } = schoolContext.subscription;

  switch (route) {
    case RoutesEnum.DEFAULT:
      return true;
    case RoutesEnum.KNOWLEDGE_BASE:
      return knowledgeBase;
    case RoutesEnum.PODCAST:
      return podcast;
    case RoutesEnum.LEARN:
      return learn;
    case RoutesEnum.MISSION:
      return mission;
    case RoutesEnum.BOOKMARK:
      return bookmark;
    case RoutesEnum.SEARCH:
      return search;
    case RoutesEnum.RESOURCE_HUB:
      return resourceHub;
    case RoutesEnum.REPORTING_TOOLS:
      return authentication?.user?.access_control_list?.reportingTools;
    case RoutesEnum.MANAGE_STAFFS:
      return authentication?.user?.access_control_list?.manageStaff;
    default:
      return false;
  }
}

export default function withAuthGuard(WrappedComponent: React.ReactNode, route: RoutesEnum) {
  const autentication = getAuthentication();

  if (!autentication || !autentication.user) {
    return <Navigate to="/login" />;
  }

  if (!isAuthorized(route)) {
    return <Navigate to="/not-authorized" />;
  }

  return WrappedComponent;
}
